import React  from 'react';

import { Text, Text2, Text3, HeaderUp } from './styles';
import ModalUnitChoice from '../../Components/Modal/UnitChoice'
import UserIcon from '../../assets/user_icon.png';
import { profile } from '../../constants'
import HomeIcon from '../../assets/icon_home.svg';
import ManagementIcon from '../../assets/icon_people.svg';
import ReportIcon from '../../assets/icon_document.svg';
import DocumentSearchIcon from '../../assets/icon_document-search.svg';
import {
    MenuContainer,
  } from './styles'
import { withRouter } from 'react-router-dom';

class Header extends React.Component {
    constructor(props) {
        super(props);
        const userPictureContainsData = /^data:/.test(this.props.handleUser.picture)
        const userPictureContainsBase64 = /.?base64,?/.test(this.props.handleUser.picture)
        const userInfo = JSON.parse(localStorage.getItem('user'));
        this.state = { 
            name: props.handleUser.name,
            picture: (userPictureContainsData && userPictureContainsBase64)? this.props.handleUser.picture : " ",
            organ: props.handleUser.organ,
            perfil: props.handleUser.perfil,
            history: props.history,
            modalUnitOption: false,
            listaUnidadesOptions: userInfo && userInfo.lista_unidades_options
        };
    };

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.handleUser !== prevProps.handleUser) {
            const userPictureContainsData = /^data:/.test(this.props.handleUser.picture)
            const userPictureContainsBase64 = /.?base64,?/.test(this.props.handleUser.picture)
            const userInfo = JSON.parse(localStorage.getItem('user'));
            this.setState({
            name: this.props.handleUser.name,
            picture: (userPictureContainsData && userPictureContainsBase64)? this.props.handleUser.picture : " ",
            organ: this.props.handleUser.organ,
            perfil: this.props.handleUser.perfil,
            history: this.props.history,
            unit: JSON.parse(localStorage.getItem('user')).unidade,
            modalUnitOption: false,
            listaUnidadesOptions: userInfo && userInfo.lista_unidades_options
          });
        }
    };
    
    render() {
        return (
            <>
                <HeaderUp showInfo={this.props.showInfo}>
                    <div className="br-header">
                        <div className="container-lg">
                            <div className="header-top">
                                <div className="header-logo">
                                    <a href="https://www.gov.br/pt-br" rel="noreferrer" target="_blank">
                                        <img 
                                            src="https://upload.wikimedia.org/wikipedia/commons/1/11/Gov.br_logo.svg" 
                                            alt="govlogo" 
                                        />
                                    </a>
                                </div>
                                <div className="header-actions" id='UserInfo'>

                                    <div style={{ 'marginRight': '10px', 'display': 'grid' }}>
                                        <Text2>
                                            {
                                                {
                                                    S: 'Administrador,',
                                                    O: 'Gestor(a) de Órgão/Entidade,',
                                                    R: 'Gestor(a) Regional,',
                                                    A: 'Atendente,',
                                                }[this.state.perfil] || null
                                            }
                                        </Text2>
                                        <Text>
                                            {this.state.name}
                                        </Text>
                                        <Text2>
                                            {this.state.organ}
                                        </Text2>
                                        {['R', 'A'].includes(this.state.perfil) &&
                                            <Text3 onClick={()=>{if (this.state.listaUnidadesOptions.length > 0) this.setState({...this.state, modalUnitOption: true})}}>
                                                {this.state.unit}
                                            </Text3>
                                        }
                                    </div>

                                    <div className="header-avatar">
                                        <span className="br-avatar" title="Foto do usuário">
                                            <span className="image">
                                                <img src={this.state.picture.trim() || UserIcon} alt="userPicture"/>
                                            </span>
                                        </span>
                                    </div>

                                    <div className="header-login">
                                        <div className="header-sign-in">
                                            <button id="btnLogout" className="br-button sign-in" 
                                                    type="button"
                                                    onClick={() => {      
                                                        fetch(`${process.env.REACT_APP_API_URL}/logout`, {
                                                            method: 'GET',
                                                            headers: {
                                                            authorization: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : '',
                                                            Accept: 'application/json',
                                                            },
                                                        });                                              
                                                        const { REACT_APP_LOGIN_UNICO_URL,REACT_APP_REDIRECT_URI_LOGOUT} = process.env;//, REACT_APP_RESPONSE_TYPE, REACT_APP_CLIENT_ID, REACT_APP_SCOPE, REACT_APP_REDIRECT_URI, REACT_APP_NONCE, REACT_APP_STATE } 
                                                        // const urlLogin = `${REACT_APP_LOGIN_UNICO_URL}/authorize?response_type=${REACT_APP_RESPONSE_TYPE}&client_id=${REACT_APP_CLIENT_ID}&scope=${REACT_APP_SCOPE}&redirect_uri=${REACT_APP_REDIRECT_URI}&nonce=${REACT_APP_NONCE}&state=${REACT_APP_STATE}`;
                                                        localStorage.clear();                                                                                                        
                                                        const possibleURLs = ["https://sso.validacao.acesso.gov.br", "https://sso.staging.acesso.gov.br", "https://sso.acesso.gov.br"];
                                                        if (possibleURLs.includes(REACT_APP_LOGIN_UNICO_URL)) {
                                                            window.location.href = `${REACT_APP_LOGIN_UNICO_URL}/logout?post_logout_redirect_uri=${REACT_APP_REDIRECT_URI_LOGOUT}`}        
                                                            else { alert("Error: URL não está contida na lista de possívels URLs do sistema. Contacte o suporte")}                                                      
                                                        }}>
                                                Sair
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </HeaderUp>
                <MenuContainer showInfo={this.props.showInfo}>
                    <div className="navbar">
                        <div className="navbar-item">
                            <i className="icon-home"><img src={HomeIcon} width="30px" alt="homeIcon" title="Home" /></i>
                            <span onClick={() => this.props.history.push('/pesquisarcidadao')}>Home</span>
                        </div>
                        {(this.state.perfil === profile.gestorSistema) && (
                        <>
                            <div className="navbar-item dropdown">
                                <i className="icon-users"><img src={ManagementIcon} width="25px" alt="managementIcon" title="Gestão" /></i>
                                <span>Gestão</span>
                                <div className="dropdown-content">
                                    <span onClick={() => this.props.history.push('/gerenciarOrgao')}>Rede de Atendimento</span>
                                    <span onClick={() => this.props.history.push('/gerenciarGestoresOrgao')}>Gestores de Rede de Atendimento</span>
                                    <span onClick={() => this.props.history.push('/bloquearDesbloquear')}>Bloqueio e Desbloqueio de Usuários</span>
                                    <span onClick={() => this.props.history.push('/horarios')}>Horários de Atendimentos</span>
                                </div>
                            </div>
                        </>
                        )}
                        {(this.state.perfil === profile.gestorOrgao) && (
                        <>
                            <div className="navbar-item dropdown">
                                <i className="icon-users"><img src={ManagementIcon} width="25px" alt="managementIcon" title="Gestão" /></i>
                                <span>Gestão</span>
                                <div className="dropdown-content">
                                    <span onClick={() => this.props.history.push('/gerenciarGestoresRegionais')}>Gestão de Gestores Regionais</span>
                                    <span onClick={() => this.props.history.push('/gerenciarUnidades')}>Gestão de Unidades</span>
                                    <span onClick={() => this.props.history.push('/horarios')}>Gestão de Horários para Gestores Regionais</span>
                                </div>
                            </div>
                        </>
                        )}
                        {(this.state.perfil === profile.gestorRegional) && (
                            <div className="navbar-item dropdown">
                                <i className="icon-users"><img src={ManagementIcon} width="25px" alt="managementIcon" title="Gestão" /></i>
                                <span>Gestão</span>
                                <div className="dropdown-content">
                                    <span onClick={() => this.props.history.push('/gerenciaratendentes')}>Gestão de Atendente</span>
                                    <span onClick={() => this.props.history.push('/horariosUnidades')}>Gestão de horários de exceção para Unidade</span>
                                    <span onClick={() => this.props.history.push('/horarios')}>Gestão de Horários para Atendentes</span>                                    
                                </div>
                            </div>
                        )}
                        {(this.state.perfil !== profile.atendente) && (
                            <div className="navbar-item dropdown">
                                <i className="icon-report"><img src={ReportIcon} width="25px" alt="reportIcon" title="Relatórios" /></i>
                                <span>Relatórios</span>
                                <div className="dropdown-content">
                                    {(this.state.perfil === profile.gestorSistema) && (
                                        <>                                            
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorOrgao')}>Atendimentos por rede de atendimento</span>
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorOrgaoUnidade')}>Atendimentos por rede ou unidade de atendimento</span>
                                            <span onClick={() => this.props.history.push('/relGestoresPorOrgao')}>Gestores cadastrados por rede de atendimento</span> 
                                            <span onClick={() => this.props.history.push('/relAtendentesPorOrgaoMes')}>Atendentes cadastrados por rede de atendimento por mês</span> 
                                            <span onClick={() => this.props.history.push('/relUnidadesPorOrgao')}>Unidades por rede de atendimento</span>
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorAtendente')}>Atendimentos por atendente</span>
                                        </>
                                    )}
                                    {(this.state.perfil === profile.gestorOrgao) && (
                                        <>
                                            <span onClick={() => this.props.history.push('/relAtendimentosOrgao')}>Atendimentos do órgão/entidade</span>
                                            <span onClick={() => this.props.history.push('/relAtendentesDoOrgaoPorMes')}>Atendentes por mês</span>
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorUnidade')}>Atendimentos Sintético por Unidade</span>
                                        </>
                                    )}
                                    {((this.state.perfil === profile.gestorSistema) || (this.state.perfil === profile.gestorOrgao)) && (
                                        <>
                                            <span onClick={() => this.props.history.push('/relAtendentesPorGestorMes')}>Atendentes por gestor por mês</span> 
                                            <span onClick={() => this.props.history.push('/relAtendentesPorGestorMesUnidade')}>Atendentes por unidade, por gestor e por mês - a partir de 24/01/2025</span> 
                                        </>
                                    )}
                                    {(this.state.perfil === profile.gestorRegional) && (
                                        <>
                                            <span onClick={() => this.props.history.push('/relAtendimentosUnidade')}>Atendimentos da unidade</span> 
                                        </>
                                    )}
                                    {((this.state.perfil === profile.gestorOrgao) || (this.state.perfil === profile.gestorRegional)) && (
                                        <>
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorFluxo')}>Atendimentos por fluxo</span>
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorAtendente')}>Atendimentos por atendente</span>  
                                            <span onClick={() => this.props.history.push('/relAtendimentosPorAtendentePorUnidade')}>Atendimentos por atendente por unidade - a partir de 24/01/2025</span> 
                                        </>
                                    )}
                                </div>
                            </div>      
                        )}                    
                        {((this.state.perfil === profile.gestorOrgao) || (this.state.perfil === profile.gestorSistema)) && (
                            <div className="navbar-item dropdown">
                                <i className="icon-service"><img src={DocumentSearchIcon} width="25px" alt="documentSearchIcon" title="Consultas" /></i>
                                <span>Consultas</span>
                                <div className="dropdown-content">
                                    <span onClick={() => this.props.history.push('/consultaratendimento')}>Consulta de Atendimento</span>                                
                                </div>
                            </div>
                        )}
                    </div>
                </MenuContainer>
                <ModalUnitChoice 
                    id="modalUnitOption"
                    appear={this.state.modalUnitOption}
                    unitListOptions={this.state.listaUnidadesOptions}
                    title={"Escolha sua unidade."}
                    textButton1={"Ok"}    
                    errorMessageNotChose={"Por favor, escolha sua unidade."}
                    errorMessageNotAllowed={'Você precisa logar com um certificado digital autorizado para atuar nesta unidade.'}
                    actionButton1={(chosenUnit) => {
                        let user = JSON.parse(localStorage.getItem('user'))
                        user.codigo_unidade = chosenUnit.value;
                        user.unidade = chosenUnit.label;
                        localStorage.setItem('user', JSON.stringify(user));
                        this.setState({...this.state, unit: user.unidade, modalUnitOption: false})
                        window.location.reload();
                    }}
                />
            </>
        );
    }
}

export default withRouter(Header);